import React, { useState, useEffect } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { H5, H6 } from '../../../AbstractElements';
import { Users, UserCheck, UserX } from 'react-feather';
import { getUsers } from '../../../api/userCheckIn';

const UserStatsWidget = () => {
  const [stats, setStats] = useState({
    total: 0,
    followed: 0,
    notFollowed: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await getUsers({ page: 1, limit: 100 });
      
      let userData = [];
      if (response?.data?.users && Array.isArray(response.data.users)) {
        userData = response.data.users;
      } else if (response?.data && Array.isArray(response.data)) {
        userData = response.data;
      } else if (response?.users && Array.isArray(response.users)) {
        userData = response.users;
      } else if (Array.isArray(response)) {
        userData = response;
      }
      
      // Get total count from pagination if available
      const totalUsers = response?.data?.pagination?.total || userData.length;
      const followed = userData.filter(user => user.followedOA).length;
      
      // Calculate percentages for current batch and scale to total
      const followedPercentage = userData.length > 0 ? (followed / userData.length) : 0;
      
      setStats({
        total: totalUsers,
        followed: Math.round(totalUsers * followedPercentage),
        notFollowed: totalUsers - Math.round(totalUsers * followedPercentage)
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const widgets = [
    {
      title: 'Total Users',
      value: stats.total,
      icon: Users,
      color: 'primary',
      bgColor: 'light-primary'
    },
    {
      title: 'Followed OA',
      value: stats.followed,
      icon: UserCheck,
      color: 'success',
      bgColor: 'light-success'
    },
    {
      title: 'Not Followed',
      value: stats.notFollowed,
      icon: UserX,
      color: 'warning',
      bgColor: 'light-warning'
    }
  ];

  return (
    <Row className='g-3'>
      {widgets.map((widget, i) => {
        const Icon = widget.icon;
        return (
          <Col key={i} xl='4' md='4' sm='12'>
            <Card className='currency-widget h-100'>
              <CardBody>
                <div className='d-flex align-items-center justify-content-between mb-3'>
                  <div className={`currency-icon-widget bg-${widget.bgColor} p-3 rounded`}>
                    <Icon size={24} className={`text-${widget.color}`} />
                  </div>
                  <div className='text-end'>
                    <H6 attrH6={{ className: 'f-light f-14 mb-1' }}>{widget.title}</H6>
                    <H5 attrH5={{ className: `f-w-600 text-${widget.color} mb-0` }}>
                      {loading ? '...' : widget.value}
                    </H5>
                  </div>
                </div>
                <div className='progress-showcase mt-3'>
                  <div className='progress sm-progress-bar'>
                    <div 
                      className={`progress-bar bg-${widget.color}`} 
                      role='progressbar' 
                      style={{ width: loading ? '0%' : '100%' }} 
                      aria-valuenow={widget.value} 
                      aria-valuemin='0' 
                      aria-valuemax='100'
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

export default UserStatsWidget;

